import React from "react";
import classNames from "classnames";
import "./Spinner.scss";

/** Пропсы {@link Spinner}. */
export interface SpinnerProps {
    /** Размер индикатора. */
    size?: "sm" | "md" | "lg";
    className?: string;
    /** Текст для screen readers. */
    label?: string;
}

/**
 * Индикатор загрузки для кнопок и inline-состояний.
 */
export const Spinner: React.FC<SpinnerProps> = ({ size = "md", className, label = "Загрузка" }) => (
    <span className={classNames("shared_spinner", `shared_spinner--${size}`, className)} role="status" aria-label={label} />
);
